import {APP_SETTINGS} from 'ro-webapp-backend';
import AppState       from './state/app';

const log = require('debug')('ro:swRegister');
// In production, we register a service worker to serve assets from local cache.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export default function register() {
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
        log(`Registering sw. Env: ${process.env.NODE_ENV}`);
        // The URL constructor is available in all browsers that support SW.
        const publicUrl = new URL(AppState.state.settings[APP_SETTINGS.BASE_URL].replace(/\/$/, ''), window.location);
        log(`Public url: ${publicUrl}`);
        if (publicUrl.origin !== window.location.origin) {
            log(`Url mismatch ${publicUrl.origin} vs. ${window.location.origin}`);
            return Promise.resolve();
        }

        // window.addEventListener('load', () => {
            const swUrl = `${AppState.state.settings[APP_SETTINGS.BASE_URL].replace(/\/$/, '')}/sw.js`;

            if (!isLocalhost) {
                log('Not local env');
                // Is not local host. Just register service worker
                return registerValidSW(swUrl);
            } else {
                log('local env');
                // This is running on localhost. Lets check if a service worker still exists or not.
                return checkValidServiceWorker(swUrl);
            }
        // });
    } else {
        log(`SW not available or not in production environment`);
    }
}

function registerValidSW(swUrl) {
    log(`Registering sw ${swUrl}`);
    return navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
        registration.onupdatefound = () => {
            const installingWorker         = registration.installing;
            installingWorker.onstatechange = () => {
                if (installingWorker.state === 'installed') {
                    if (navigator.serviceWorker.controller) {
                        // At this point, the old content will have been purged and
                        // the fresh content will have been added to the cache.
                        // It's the perfect time to display a "New content is
                        // available; please refresh." message in your web app.
                        console.log('New content is available; please refresh.');
                    } else {
                        // At this point, everything has been precached.
                        // It's the perfect time to display a
                        // "Content is cached for offline use." message.
                        console.log('Content is cached for offline use.');
                    }
                }
            };
        };
    })
    .catch(error => {
        console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl) {
    // Check if the service worker can be found. If it can't reload the page.
    return fetch(swUrl)
    .then(response => {
        // Ensure service worker exists, and that we really are getting a JS file.
        if (
            response.status === 404 ||
            response.headers.get('content-type').indexOf('javascript') === -1
        ) {
            // No service worker found. Probably a different app. Reload the page.
            navigator.serviceWorker.ready.then(registration => {
                registration.unregister().then(() => {
                    window.location.reload();
                });
            });
        } else {
            // Service worker found. Proceed as normal.
            return registerValidSW(swUrl);
        }
    })
    .catch(() => {
        console.log(
            'No internet connection found. App is running in offline mode.'
        );
    });
}

export function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(registration => {
            registration.unregister();
        });
    }
}



// WEBPACK FOOTER //
// ./src/registerServiceWorker.js